import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './left-side-live-transaction.vue';

import * as Store from '../../store';
import { LiveData } from '../../views/live/index';

// Websockets
import { WebsocketsListener } from '../../utils/ws';

@Component({
    mixins: [template],
})
export default class LeftSideLiveTransaction extends Vue {
    @Prop(Object) readonly auctionData!: LiveData;

    wsListener: WebsocketsListener;

    constructor() {
        super();

        this.wsListener = new WebsocketsListener();
    }

    destroyed() {
        this.wsListener.destroy();
    }

    bidAuction() {
        (this as any).$confirm({
            title: 'Atenție!',
            message: `Sunteți sigur că doriți să licitați €${
                this.auctionData.currentPrice
            }?`,
            button: {
                no: 'Nu',
                yes: 'Da, sunt sigur!',
            },
            /**
             * Callback Function
             * @param {Boolean} confirm
             */
            callback: (confirm: any) => {
                if (confirm) {
                    this.wsListener.sendPost('live.bid', {
                        auction: this.auctionData.auction._id,
                        lot: this.auctionData.currentLot._id,
                        price: this.auctionData.prices.current._id,
                    });
                }
            },
        });
    }

    verifyEmail() {
        if (this.$root.$options && this.$root.$options.router) {
            this.$root.$options.router.push('/verify');
        }
    }

    joinAuction() {
        this.wsListener.sendPost('live.join', {
            auction: this.auctionData.auction._id,
        });
    }

    getAuctionIdFromURL(url: any) {
        let result: any = {};

        let anchor = document.createElement('a');
        anchor.href = url;

        let keys = 'protocol hostname host pathname port search hash href'.split(
            ' ',
        );
        for (let keyIndex in keys) {
            let currentKey = keys[keyIndex];
            result[currentKey] = anchor[currentKey];
        }

        result.toString = function() {
            return anchor.href;
        };
        result.requestUri = result.pathname + result.search;
        result = result.requestUri.split('/')[2];
        return result;
    }

    joinPlatform() {
        this.$store.state.currentAuctionID = this.getAuctionIdFromURL(
            window.location.href,
        );

        this.$router.push(
            '/login?auction=' + this.getAuctionIdFromURL(window.location.href),
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/left-side-live-transaction/index.ts